import { Router } from '@angular/router';

export type NavigationItems = {
	icon: string;
	label: string;
	disabled: boolean;
	route: string;
	selected: boolean;
	labelId: string;
	applicationType: ApplicationType;
	navigateUrl?: string;
	permission?: string;
	/**
	 * If set, the side nav will call this function to determine if the route is active.
	 * Otherwise, it will use Angular's built-in route matching.
	 */
	checkActive?(router: Router): boolean;
};
export enum ApplicationType {
	CloudDeviceManagement = 'cloud-device-management',
	OrganizationPortal = 'organization-portal'
}
export enum RoleViewPermissions {
	ViewDeviceManagement = 'viewDeviceManagement'
}

export type PermissionsList = {
	[key in RoleViewPermissions]?: boolean;
};
